import { paths } from '@/configs/paths'
import { isAuthenticated } from '@/utils/auth'
import { Navigate, useMatches } from 'react-router-dom'
import { useAppStore } from '@/stores'
import type { UserRole } from '@/constants/common'
import AccessDenied from '@/components/layouts/base/AccessDenied'

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user = useAppStore((state) => state.user)
  const matches = useMatches()

  if (!isAuthenticated()) {
    return <Navigate to={paths.login.path} replace />
  }

  const currentRoute = matches[matches.length - 1]
  const handle = currentRoute?.handle as { allowedRoles?: UserRole[] } | undefined
  const allowedRoles = handle?.allowedRoles

  const isAuthorized = () => {
    if (!allowedRoles || allowedRoles.length === 0) {
      return true
    }
    return user?.role_name && allowedRoles.includes(user.role_name)
  }

  if (!isAuthorized()) {
    return <AccessDenied />
  }

  return children
}
